module.exports = __webpack_public_path__ + "media/טס.0a71a597.mp3";